export default {
  root: {
    minHeight: '100vh',
  },
  rootItem: {
    maxWidth: 550,
    padding: 40,
  },
};
